export default "__VITE_ASSET__BXiYEYRC__"